import React from "react";
import { motion } from "framer-motion";
import { PILLARS } from "../data/content";

export default function Pillars() {
  return (
    <section id="services" className="vw-section relative" data-testid="vw-pillars">
      <div className="vw-container">
        <div className="mb-16 md:mb-24 flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8">
          <div className="max-w-2xl">
            <div className="vw-eyebrow mb-6">WHAT YOU GET · IN THREE LINES</div>
            <h2 className="font-display text-5xl md:text-6xl lg:text-7xl leading-[0.92] tracking-tight">
              A lower budget. A tighter schedule. And <span className="font-serif-italic font-normal text-[var(--vw-cyan)]">the frame you signed off on</span>.
            </h2>
          </div>
          <p className="max-w-md text-[var(--vw-text-dim)] leading-relaxed text-lg">
            Three offers, under one roof — engineered to protect your budget, hit your delivery date, and hand you the master your buyer approved.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-px bg-[var(--vw-border)]">
          {PILLARS.map((p, i) => (
            <motion.div
              key={p.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] }}
              className="group relative bg-[var(--vw-bg)] p-8 md:p-10 hover:bg-[var(--vw-surface)] transition-colors duration-500 min-h-[440px] flex flex-col"
              data-testid={`vw-pillar-${p.id}`}
            >
              <div className="flex items-start justify-between mb-8">
                <span className="font-mono text-[10px] uppercase tracking-[0.28em] text-[var(--vw-text-mute)]">
                  {p.kicker}
                </span>
                <span className="font-display text-6xl leading-none text-[var(--vw-cyan)] opacity-25 group-hover:opacity-100 transition-opacity duration-500">
                  {p.number}
                </span>
              </div>
              <h3 className="font-display text-4xl leading-[0.95] mb-6 text-[var(--vw-text)]">
                {p.title}
              </h3>
              <p className="text-[var(--vw-text-dim)] leading-relaxed mb-8 flex-1">
                {p.body}
              </p>
              <ul className="space-y-2.5 border-t border-[var(--vw-border)] pt-6">
                {p.bullets.map((b) => (
                  <li key={b} className="flex items-center gap-3 font-mono text-[11px] uppercase tracking-[0.16em] text-[var(--vw-text-dim)]">
                    <span className="w-4 h-px bg-[var(--vw-cyan)]" />
                    {b}
                  </li>
                ))}
              </ul>
              <div className="absolute top-0 left-0 h-px w-0 bg-[var(--vw-cyan)] group-hover:w-full transition-all duration-700" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
